import React from 'react'
import { UploadCriminalRecordCheck } from './UploadCriminalRecordCheck'

export const UploadCriminalRecordCheckAgency = (props) => {
    return (
        <UploadCriminalRecordCheck 
            {...props}
            forPrimaryAgency
        />
    )
}
